<section
  *ngIf="{
    isLayoutHidden: isLayoutHidden$ | async,
    isWindowAtTop: isWindowAtTop$ | async,
    isHandset: isHandset$ | async,
    closeHandsetSidebarOnRouteChange: closeHandsetSidebarOnRouteChange$ | async,
    onToggleMenu: onToggleMenu$ | async
  } as STATE"
  class="content-wrapper"
>
  <mat-toolbar
    #toolbar
    *ngIf="!STATE.isLayoutHidden && STATE.isHandset"
    color="secondary"
    class="mat-elevation-z6"
  >
    <button
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="drawer?.toggle()"
    >
      <i class="fa fa-bars" aria-label="Side nav toggle icon"></i>
    </button>

    <a [routerLink]="'/'">
      <img
        [lazyLoad]="'assets/images/adtrack-logo.svg'"
        width="10"
        alt="Adtrack's logo"
      />
    </a>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav
      *ngIf="!STATE.isLayoutHidden"
      class="sidenav"
      [ngClass]="isSidenavCollapsed ? 'sidenav--collapsed' : ''"
      fixedInViewport
      [attr.role]="STATE.isHandset ? 'dialog' : 'navigation'"
      [mode]="STATE.isHandset ? 'over' : 'side'"
      [opened]="STATE.isHandset || STATE.isLayoutHidden ? false : true"
      [style.margin-top.px]="toolbarHeight"
    >
      <a
        [routerLink]="'/'"
        class="sidenav__logo w-full p-1 max-w-40 block !mx-auto"
      >
        <img
          [lazyLoad]="'assets/images/adtrack-logo.svg'"
          alt="Adtrack's logo"
        />
      </a>
      <div class="sidenav__menu">
        <mat-list>
          <mat-accordion [multi]="false">
            @for (link of sidebarLinks; track link.id) {
              <ng-container
                *ngxPermissionsExcept="link.permissions?.except || []"
              >
                <ng-container
                  *ngxPermissionsOnly="link.permissions?.only || []"
                >
                  @if (link.children && link.children.length) {
                    <mat-expansion-panel
                      #panel
                      (click)="onSidebarLinkClick(link)"
                      class="mat-elevation-z0"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          @if (link.iconUrl) {
                            <svg-icon [src]="link.iconUrl" icon></svg-icon>
                          }
                          <span class="mdc-list-item__label">{{
                            link.label
                          }}</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      @for (childLink of link.children; track childLink.id) {
                        <ng-container
                          *ngxPermissionsExcept="
                            childLink.permissions?.except || []
                          "
                        >
                          <a
                            mat-list-item
                            [routerLink]="childLink.url"
                            routerLinkActive="mdc-list-item--active"
                            [routerLinkActiveOptions]="{
                              exact: childLink.exactActive || false
                            }"
                            [matTooltip]="isSidenavCollapsed ? link.label : ''"
                            matTooltipPosition="after"
                            *ngxPermissionsOnly="
                              childLink.permissions?.only || []
                            "
                          >
                            @if (childLink.iconUrl) {
                              <svg-icon
                                [src]="childLink.iconUrl"
                                icon
                              ></svg-icon>
                            }
                            <span class="mdc-list-item__label">{{
                              childLink.label
                            }}</span>
                          </a>
                        </ng-container>
                      }
                    </mat-expansion-panel>
                  } @else {
                    <ng-container
                      *ngxPermissionsExcept="link.permissions?.except || []"
                    >
                      <a
                        mat-list-item
                        [routerLink]="link.url"
                        routerLinkActive="mdc-list-item--active"
                        [routerLinkActiveOptions]="{
                          exact: link.exactActive || false
                        }"
                        [matTooltip]="isSidenavCollapsed ? link.label : ''"
                        matTooltipPosition="after"
                        *ngxPermissionsOnly="link.permissions?.only || []"
                      >
                        @if (link.iconUrl) {
                          <svg-icon [src]="link.iconUrl" icon></svg-icon>
                        }
                        <span class="mdc-list-item__label">{{
                          link.label
                        }}</span>
                      </a>
                    </ng-container>
                  }
                </ng-container>
              </ng-container>
            }
          </mat-accordion>
        </mat-list>
      </div>
      <button
        type="button"
        class="collapse-btn"
        [class.collapse-btn--hidden]="STATE.isHandset"
        [matTooltip]="isSidenavCollapsed ? 'Agrandir le menu' : ''"
        matTooltipPosition="after"
        (click)="toggleSidenav()"
      >
        <img
          class="collapse-btn__icon"
          [lazyLoad]="
            'assets/icons/chevron-' +
            (isSidenavCollapsed ? 'right' : 'left') +
            '.svg'
          "
          alt="chevron svg"
        />
        <span class="collapse-btn__label">Rétrécir le menu</span>
      </button>
      <small class="sidenav__footer">Powered by VEONE</small>
    </mat-sidenav>
    <mat-sidenav-content>
      <main
        class="content-wrapper__content"
        [style.padding-top.px]="
          !STATE.isLayoutHidden && STATE.isHandset ? 0 : toolbarHeight
        "
      >
        <toolbar *ngIf="!STATE.isLayoutHidden"></toolbar>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</section>
